<template>
  <div
    class="bg-static-default-low rounded-md flex flex-col items-center px-8 pb-8 pt-16"
  >
    <component :is="icon" />

    <p class="body-2-bold mb-16 mt-8">
      {{ title }}
    </p>

    <div class="flex flex-col space-y-8">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

interface VersusTableProps {
  title: string
  icon: Component
}
defineProps<VersusTableProps>()
</script>
